// import React from 'react';
// import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import SdgScoreClob from './_sdgScoreClob';
import { AffinityDto } from 'models/dtoTypes';

const PREFIX = '_reportAppendixClob';

const classes = {
  code: `${PREFIX}-code`,
  description: `${PREFIX}-description`,
};

const ItemRoot = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  [`& .${classes.code}`]: {
    width: 60,
    fontWeight: 'bold',
  },
  [`& .${classes.description}`]: {
    flex: 1,
  },
}));

interface IProps {
  title: string;
  sdgId?: string;
  anchor?: string;
  autoHeight?: boolean;
  affinity?: AffinityDto;
  detailList: string[];
}

export default function ReportAppendixClob(props: IProps): JSX.Element {
  const { title, autoHeight, anchor, sdgId, affinity, detailList } = props;

  const renderSingleListItem = (item: string, index: number) => {
    return (
      <ListItem key={index}>
        <ListItemText
          primary={
            <ItemRoot>
              <div className={classes.description}>{item}</div>
            </ItemRoot>
          }
        />
      </ListItem>
    );
  };
  const renderAllListItems = (items: string[]) => {
    return (
      <Box
        sx={{
          width: '100%',
          height: autoHeight ? 'auto' : 200,
          bgcolor: 'background.paper',
          overflowY: autoHeight ? 'hidden' : 'scroll',
          overflowX: 'hidden',
        }}
      >
        <List>{items.map(renderSingleListItem)}</List>
      </Box>
    );
  };

  return (
    <Box
      component="div"
      sx={{
        width: '100%',
        p: 0,
        mt: 1,
        mb: 1,
        border: '2px solid #808080',
      }}
    >
      <SdgScoreClob sdgId={sdgId} anchor={anchor} title={title} affinity={affinity} withBg={true} />
      <Divider sx={{ borderBottom: '2px solid #808080' }} />
      {renderAllListItems(detailList)}
    </Box>
  );
}
